import "./area.css";
import { OperationAreaProps } from "./area.props";
import { ArrowRightFill } from "../../../assets";
import {
  ActiveFilters,
  OperationExportData,
  OperationFilterButton,
  OperationSearch,
  OperationToolbarButton,
} from "./components";
import { OperationCalendarRange } from "./components/calendar";

const OperationArea: React.FC<OperationAreaProps> = ({
  className,
  title,
  filter,
  calendar,
  exportdata,
  search,
  toolbarButton,
  children,
  buttonFooter,
  footer,
}) => {
  return (
    <section className={`operation-area ${className}`}>
      <div
        className={`operation-area-header ${
          filter !== undefined && filter?.show && filter.filters.length
            ? "filters"
            : ""
        } ${
          !title &&
          (filter === undefined || !filter.show) &&
          (calendar === undefined || !calendar?.show) &&
          (exportdata === undefined || !exportdata.show) &&
          (search === undefined || !search.show) &&
          (toolbarButton === undefined || !toolbarButton.show)
            ? "none"
            : ""
        }`}
      >
        {title && <h2 className="operation-area-title">{title}</h2>}

        <div
          className={`operation-area-reorder ${
            filter !== undefined && filter.show
              ? "operation-area-reorder left"
              : "operation-area-reorder right"
          }`}
        >
          {filter !== undefined && (
            <OperationFilterButton
              className="operation-area-filter"
              {...filter}
            />
          )}
          {calendar !== undefined && (
            <OperationCalendarRange
              className="operation-area-calendar"
              {...calendar}
            />
          )}
          {exportdata !== undefined && (
            <OperationExportData
              className="operation-area-exportdata"
              {...exportdata}
            />
          )}
          {search !== undefined && (
            <OperationSearch className="operation-area-search" {...search} />
          )}
          {toolbarButton !== undefined && (
            <OperationToolbarButton
              className="operation-area-toolbarbutton"
              {...toolbarButton}
            />
          )}
        </div>
      </div>
      {filter !== undefined && filter?.show && (
        <ActiveFilters
          filters={filter.filters}
          pathFilterL={filter.pathFilterL}
          formatValue={filter.formatValue}
          deleteByKey={filter.deleteByKey}
          deleteAll={filter.deleteAll}
        />
      )}

      {children}

      <div className="operation-area-footer">
        {footer}

        {buttonFooter?.show && (
          <>
            {buttonFooter.type === "link" ? (
              <>
                {buttonFooter.disabled ? (
                  <>
                    <div
                      className={`operation-area-footer-button disabled ${buttonFooter.className}`}
                    >
                      <img
                        src={ArrowRightFill}
                        alt="Icon arrow right"
                        className="operation-area-footer-button-icon"
                      />
                      <p>{buttonFooter.text}</p>
                    </div>
                  </>
                ) : (
                  <>
                    <a
                      className={`operation-area-footer-button ${buttonFooter.className}`}
                      href={buttonFooter?.link ?? ""}
                      target="_top"
                    >
                      <img
                        src={ArrowRightFill}
                        alt="Icon arrow right"
                        className="operation-area-footer-button-icon"
                      />
                      <p>{buttonFooter.text}</p>
                    </a>
                  </>
                )}
              </>
            ) : (
              <>
                <button
                  className={`operation-area-footer-button ${
                    buttonFooter.disabled ? "disabled" : ""
                  } ${buttonFooter.className}`}
                  onClick={buttonFooter.onClick}
                  disabled={buttonFooter.disabled}
                >
                  <img
                    src={ArrowRightFill}
                    alt="Icon arrow right"
                    className="operation-area-footer-button-icon"
                  />
                  <p>{buttonFooter.text}</p>
                </button>
              </>
            )}
          </>
        )}
      </div>
    </section>
  );
};

export default OperationArea;
